export const ENVIRONMENT = "DemoAlice";
export const ENVIRONMENT_LIST = [{ label: 'DemoAlice', value: 'DemoAlice' }];
